import * as React from 'react';
import { Route } from 'react-router';
import { connect } from 'react-redux';
import { LocalizeState, getMessages } from 'src/api';
import DefaultRouter from './DefaultRouter';
import { history } from '../redux';
import { ConnectedRouter } from 'connected-react-router';
import {addLocaleData, IntlProvider} from 'react-intl';

import * as de from 'react-intl/locale-data/de';
import * as en from 'react-intl/locale-data/en';
import * as fr from 'react-intl/locale-data/fr';
import * as cs from 'react-intl/locale-data/cs';
import * as es from 'react-intl/locale-data/es';
import * as it from 'react-intl/locale-data/it';
import * as nl from 'react-intl/locale-data/nl';
import * as pl from 'react-intl/locale-data/pl';

addLocaleData([...de, ...en, ...fr, ...cs, ...es, ...it, ...nl, ...pl]);

export interface AppProps {
  language: LocalizeState['language'];
} 

class App extends React.Component<AppProps> {
  public render() {    
    const language = this.props.language.selected || 'en-150';
    const languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];
    const messages = getMessages(this.props.language.selected || 'en-150');
    
    return (
      <IntlProvider 
        locale={language} 
        key={languageWithoutRegionCode} 
        messages={messages}
      >
        <ConnectedRouter history={history}>
          <Route component={DefaultRouter} />
        </ConnectedRouter>
      </IntlProvider>
    );
  }
}

interface StateProps {
  localize: LocalizeState; 
}

export default connect((state: StateProps) => ({
  language: state.localize.language
}))(App);
